<div *ngIf="!token" class="container row my-5">
  <h1>¡Regístrate o inicia sesión para continuar!</h1>
  <br>
  <h2>Login o registro</h2>

  <div *ngIf="!showForgotPassword">
    <form [formGroup]="contactForm">
      <p>
        <mat-form-field
          appearance="outline"
          class="controles-container botonfull"
        >
          <mat-label>Correo</mat-label>
          <input
            matInput
            type="text"
            placeholder="Ingresa tu correo"
            formControlName="email"
          />
        </mat-form-field>
      </p>
      <p>
        <mat-form-field
          appearance="outline"
          class="controles-container botonfull"
        >
          <mat-label>Contraseña</mat-label>
          <input
            matInput
            [type]="hide ? 'password' : 'text'"
            placeholder="Ingresa tu contraseña"
            formControlName="password"
          />
          <span
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
              <mat-icon color="accent">{{
                hide ? "visibility_off" : "visibility"
              }}</mat-icon>
            </span>
        </mat-form-field>
      </p>

       <p>
        <mat-form-field
          appearance="outline"
          class="controles-container botonfull"
        >
        <mat-label>Número de teléfono</mat-label>
          <input
            matInput
            type="text"
            placeholder="Ingresa tu numero de telefono"
            formControlName="phoneD"
          />
        </mat-form-field>
      </p>

      <mat-error *ngIf="error">
        {{ error }}
      </mat-error>
      <p></p>
      <div class="row justify-content-between">
        <div class="col-auto">
          <button
            type="submit"
            mat-flat-button
            color="primary"
            [disabled]="isLoginFormInvalid() || loading"
            class="controles-container"
            (click)="onLogin()"
          >
            Login
          </button>
        </div>
        <div class="col">
          <button
            type="submit"
            mat-flat-button
            color="primary"
            [disabled]="isRegisterFormInvalid() || loadingRegister"
            class="controles-container"
            (click)="register()"
          >
            Register
          </button>
        </div>
      </div>
      <div class="forgot-password-link-container">
        <span class="toggle-text" (click)="toggleForgotPassword()">
          <u style="cursor: pointer; color: #007bff;">¿Olvidaste tu contraseña?</u>
        </span>
      </div>
    </form>
  </div>

  <div *ngIf="showForgotPassword" class="forgot-password-container">
    <h2>Restablecer tu contraseña</h2>
    <form (ngSubmit)="resetPassword()">
      <div class="form-group">
        <label for="email">Ingresa tu correo electrónico</label>
        <input
          type="email"
          id="email"
          [(ngModel)]="email"
          name="email"
          class="form-control"
          required
        />
      </div>
      <div class="message-info">{{ message }}</div>
      <div class="d-flex align-items-center form-actions">
        <mat-icon (click)="toggleForgotPassword()" class="me-2 icon-hover" style="cursor: pointer;">arrow_back</mat-icon>
        <button type="submit" mat-flat-button color="primary" [disabled]="loading" class="btn-reset">
          <span *ngIf="!loading">Enviar enlace al correo</span>
        </button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="token && !orderConfirmed" class="row my-5">
  <h2>Dirección de envío</h2>
  <h2>Llene todos los campos para su envío(son obligatorios)</h2>
  <form [formGroup]="addressCheckOut">
    <div class="row">
      <div class="col-md-8">
        <div class="row g-3 my-2">
          <div class="col">
            <input type="text" class="form-control" placeholder="Nombre Completo" aria-label="Nombre completo" formControlName="name" required>
            <mat-error *ngIf="addressCheckOut.get('name')?.invalid && (addressCheckOut.get('name')?.touched || addressCheckOut.get('name')?.dirty)">
                  El nombre es requerido.
           </mat-error>
          </div>
          <div class="col">
            <input type="text" class="form-control" placeholder="Telefono" aria-label="Telefono" formControlName="phone" required>
            <mat-error *ngIf="addressCheckOut.get('phone')?.invalid && (addressCheckOut.get('phone')?.touched || addressCheckOut.get('phone')?.dirty)">
              El teléfono es requerido.
            </mat-error>
          </div>
        </div>
        <div class="row g-3 my-2">
          <div class="col">
            <input type="text" class="form-control" placeholder="Calle" aria-label="Calle" formControlName="street" required>
            <mat-error *ngIf="addressCheckOut.get('street')?.invalid && (addressCheckOut.get('street')?.touched || addressCheckOut.get('street')?.dirty)">
              La calle es requerida.
            </mat-error>
          </div>
          <div class="col">
            <input type="text" class="form-control" placeholder="Numero" aria-label="Numero" formControlName="number" required>
            <mat-error *ngIf="addressCheckOut.get('number')?.invalid && (addressCheckOut.get('number')?.touched || addressCheckOut.get('number')?.dirty)">
              El número de la casa es requerido.
            </mat-error>
          </div>
          <div class="col">
            <input type="text" class="form-control" placeholder="Colonia" aria-label="Colonia" formControlName="colony" required>
            <mat-error *ngIf="addressCheckOut.get('colony')?.invalid && (addressCheckOut.get('colony')?.touched || addressCheckOut.get('colony')?.dirty)">
              La colonia es requerida.
            </mat-error>
          </div>
        </div>
        <div class="row g-3 my-2">
          <div class="col">
            <input type="text" class="form-control" placeholder="Municipio" aria-label="Municipio" formControlName="municipality" required>
            <mat-error *ngIf="addressCheckOut.get('municipality')?.invalid && (addressCheckOut.get('municipality')?.touched || addressCheckOut.get('municipality')?.dirty)">
              El municipio es requerido.
            </mat-error>
          </div>
          <div class="col">
            <input type="text" class="form-control" placeholder="Estado" aria-label="Estado" formControlName="state" required>
            <mat-error *ngIf="addressCheckOut.get('state')?.invalid && (addressCheckOut.get('state')?.touched || addressCheckOut.get('state')?.dirty)">
              El estado es requerido.
            </mat-error>
          </div>
        </div>
        <div class="row g-3 my-2">
          <div class="col">
            <input type="number" class="form-control" placeholder="Postal Code" aria-label="Postal Code" formControlName="zipCode" required>
            <mat-error *ngIf="addressCheckOut.get('zipCode')?.invalid && (addressCheckOut.get('zipCode')?.touched || addressCheckOut.get('zipCode')?.dirty)">
              El código postal es requerido.
            </mat-error>
          </div>
          <div class="col">
            <select id="inputState" class="form-select"  formControlName="country" required>
              <option value="" disabled>Selecciona un país</option>
              <option value="Mexico">México</option>
            </select>
            <mat-error *ngIf="addressCheckOut.get('country')?.invalid && (addressCheckOut.get('country')?.touched || addressCheckOut.get('country')?.dirty)">
              El país es requerido.
            </mat-error>
          </div>
        </div>
        <div class="my-3">
          <button type="button" class="btn btn-danger" (click)="regresar()" style="background-color: #ff4d4d; color: white; border: none; cursor: pointer; transition: background-color 0.3s ease;">
            Regresar
          </button>
          <button type="button" class="btn btn-bg" (click)="confirmPedido()" style="background-color: #4CAF50; color: white;" [disabled]="!addressCheckOut.valid || isProcessingOrder">
            <span *ngIf="!isProcessingOrder">Confirmar compra</span>
            <span *ngIf="isProcessingOrder">
              <i class="fa fa-spinner fa-spin"></i> Procesando...
            </span>
          </button>
        </div>
      </div>
      <div class="col-md-4">
      </div>
    </div>
  </form>
</div>

<div class="confirm-message text-center my-5" *ngIf="orderConfirmed">
  <h2>¡Gracias por tu compra!</h2>
  <p>
    Tu pedido ha sido procesado con éxito. Puedes darle seguimiento en la sección de mis pedidos
  </p>
  <a routerLink="/pedidos" class="btn btn-primary mt-3">Mis Pedidos</a>.
  <p>
    Para cualquier detalle o duda, no olvides comunicarte con nosotros por WhatsApp.
  </p>
  <p>
    <a href="https://api.whatsapp.com/send?phone=528110760979&text=Hola, tengo una pregunta sobre mi orden número {{ orderId }}." target="_blank">
      <i class="fab fa-whatsapp" style="font-size: 2em; color: #25D366;"></i>
    </a>
  </p>
</div>